var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useRef, useCallback } from "react";
import axios from "axios";
var PREFERRED_VOICES = [
    "Microsoft Aria Online (Natural) - English (United States)",
    "Microsoft Jenny Online (Natural) - English (United States)",
    "Microsoft Zira Online (Natural) - English (United States)",
    "Google US English",
    "Microsoft Zira - English (United States)",
    "Samantha",
];
function getBestVoice() {
    var _a;
    var voices = window.speechSynthesis.getVoices();
    var _loop_1 = function (name) {
        var voice = voices.find(function (v) { return v.name === name; });
        if (voice)
            return { value: voice };
    };
    for (var _i = 0, PREFERRED_VOICES_1 = PREFERRED_VOICES; _i < PREFERRED_VOICES_1.length; _i++) {
        var name = PREFERRED_VOICES_1[_i];
        var state_1 = _loop_1(name);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return (_a = voices.find(function (v) { return v.lang.startsWith("en-US") || v.lang.startsWith("en_US"); })) !== null && _a !== void 0 ? _a : null;
}
function speak(text) {
    return new Promise(function (resolve) {
        window.speechSynthesis.cancel();
        var utterance = new SpeechSynthesisUtterance(text);
        utterance.rate = 0.92;
        utterance.pitch = 1.05;
        utterance.volume = 1.0;
        var doSpeak = function () {
            var voice = getBestVoice();
            if (voice)
                utterance.voice = voice;
            utterance.onend = function () { return resolve(); };
            utterance.onerror = function () { return resolve(); };
            window.speechSynthesis.speak(utterance);
        };
        if (window.speechSynthesis.getVoices().length === 0) {
            window.speechSynthesis.addEventListener("voiceschanged", doSpeak, { once: true });
        }
        else {
            doSpeak();
        }
    });
}
var blobToBase64 = function (blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result.split(",")[1]); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
var useVoiceInput = function (opts) {
    var _a = useState("idle"), voiceState = _a[0], setVoiceState = _a[1];
    var _b = useState(0), currentStepIndex = _b[0], setCurrentStepIndex = _b[1];
    var _c = useState(""), liveTranscript = _c[0], setLiveTranscript = _c[1];
    var _d = useState(""), statusMessage = _d[0], setStatusMessage = _d[1];
    var _e = useState(false), isActive = _e[0], setIsActive = _e[1];
    var stoppedRef = useRef(false);
    var mediaRecorderRef = useRef(null);
    var audioStreamRef = useRef(null);
    var wakeLockRef = useRef(null);
    var optsRef = useRef(opts);
    optsRef.current = opts;
    var getSteps = useCallback(function () {
        return [
            {
                key: "position",
                getQuestion: function () {
                    var names = optsRef.current.positions.map(function (p) { return p.position; }).join(", ");
                    return "What position are you working? Your options are: ".concat(names, ".");
                },
                getOptions: function () { return optsRef.current.positions.map(function (p) { return p.position; }); },
            },
            {
                key: "date",
                getQuestion: function () { return "What date are you logging for?"; },
                getOptions: function () { return []; },
            },
            {
                key: "start_time",
                getQuestion: function () { return "What is your start time?"; },
                getOptions: function () { return []; },
            },
            {
                key: "end_time",
                getQuestion: function () { return "What is your end time?"; },
                getOptions: function () { return []; },
            },
            {
                key: "vessel_name",
                getQuestion: function () {
                    var names = optsRef.current.vesselOptions.join(", ");
                    return "What type of vessel? Your options are: ".concat(names, ".");
                },
                getOptions: function () { return optsRef.current.vesselOptions; },
            },
            {
                key: "ship_name",
                getQuestion: function () { return "What is the ship name?"; },
                getOptions: function () { return optsRef.current.shipOptions; },
            },
            {
                key: "header_name",
                getQuestion: function () { return "What is the header name?"; },
                getOptions: function () { return optsRef.current.headerOptions; },
            },
        ];
    }, []);
    // Phase 1: speak the question while monitoring mic for interruption (no recording yet).
    // Phase 2: once TTS ends (naturally or interrupted), open MediaRecorder and capture answer.
    // This ensures the recorded audio never contains TTS bleed-through.
    var recordAudio = function () {
        return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var stream, _a, audioCtx, source, analyser, mimeType, recorder, chunks, recordingStopped, noSpeechFlag, bufferLength, dataArray, SILENCE_THRESHOLD, SILENCE_AFTER_SPEECH, NO_SPEECH_TIMEOUT, MAX_DURATION, recordStart, speechDetected, silenceStart, timerInterval, stopRecording, checkSilence;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                audio: { echoCancellation: true, noiseSuppression: true },
                            })];
                    case 1:
                        stream = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        reject(new Error("mic-denied"));
                        return [2 /*return*/];
                    case 3:
                        audioStreamRef.current = stream;
                        audioCtx = new AudioContext();
                        source = audioCtx.createMediaStreamSource(stream);
                        analyser = audioCtx.createAnalyser();
                        analyser.fftSize = 512;
                        source.connect(analyser);
                        mimeType = MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
                            ? "audio/webm;codecs=opus"
                            : MediaRecorder.isTypeSupported("audio/webm")
                                ? "audio/webm"
                                : "audio/ogg";
                        recorder = new MediaRecorder(stream, { mimeType: mimeType });
                        mediaRecorderRef.current = recorder;
                        chunks = [];
                        recordingStopped = false;
                        noSpeechFlag = false;
                        recorder.ondataavailable = function (e) { if (e.data.size > 0)
                            chunks.push(e.data); };
                        recorder.onstop = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var baseMime, blob, base64, e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        stream.getTracks().forEach(function (t) { return t.stop(); });
                                        audioCtx.close();
                                        audioStreamRef.current = null;
                                        mediaRecorderRef.current = null;
                                        if (noSpeechFlag || chunks.length === 0) {
                                            reject(new Error("no-speech"));
                                            return [2 /*return*/];
                                        }
                                        baseMime = mimeType.split(";")[0];
                                        blob = new Blob(chunks, { type: baseMime });
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, blobToBase64(blob)];
                                    case 2:
                                        base64 = _a.sent();
                                        resolve({ base64: base64, mimeType: baseMime });
                                        return [3 /*break*/, 4];
                                    case 3:
                                        e_1 = _a.sent();
                                        reject(e_1);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); };
                        recorder.start(100);
                        bufferLength = analyser.frequencyBinCount;
                        dataArray = new Uint8Array(bufferLength);
                        SILENCE_THRESHOLD = 15;
                        SILENCE_AFTER_SPEECH = 1500;
                        NO_SPEECH_TIMEOUT = 6000;
                        MAX_DURATION = 12000;
                        recordStart = Date.now();
                        speechDetected = false;
                        silenceStart = null;
                        timerInterval = setInterval(function () {
                            var sec = ((Date.now() - recordStart) / 1000).toFixed(1);
                            setLiveTranscript("Recording\u2026 ".concat(sec, "s"));
                        }, 100);
                        stopRecording = function () {
                            if (recordingStopped)
                                return;
                            recordingStopped = true;
                            clearInterval(timerInterval);
                            recorder.stop();
                        };
                        checkSilence = function () {
                            if (recordingStopped)
                                return;
                            if (stoppedRef.current) {
                                stopRecording();
                                return;
                            }
                            analyser.getByteFrequencyData(dataArray);
                            var rms = Math.sqrt(dataArray.reduce(function (sum, v) { return sum + v * v; }, 0) / bufferLength);
                            var elapsed = Date.now() - recordStart;
                            if (rms > SILENCE_THRESHOLD) {
                                speechDetected = true;
                                silenceStart = null;
                            }
                            else if (speechDetected) {
                                if (!silenceStart)
                                    silenceStart = Date.now();
                                if (Date.now() - silenceStart >= SILENCE_AFTER_SPEECH) {
                                    stopRecording();
                                    return;
                                }
                            }
                            else if (elapsed >= NO_SPEECH_TIMEOUT) {
                                noSpeechFlag = true;
                                stopRecording();
                                return;
                            }
                            if (elapsed >= MAX_DURATION) {
                                stopRecording();
                                return;
                            }
                            requestAnimationFrame(checkSilence);
                        };
                        requestAnimationFrame(checkSilence);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    var processWithGemini = function (field, audio, options) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post("/voice/process", {
                        audioBase64: audio.base64,
                        mimeType: audio.mimeType,
                        field: field,
                        options: options,
                    })];
                case 1:
                    response = _a.sent();
                    if (response.data.status === "success") {
                        return [2 /*return*/, {
                                value: response.data.value,
                                display: response.data.display,
                            }];
                    }
                    if (response.data.status === "error" && response.data.fallback) {
                        console.warn("Using fallback response:", response.data.message);
                        return [2 /*return*/, {
                                value: response.data.fallback.value,
                                display: response.data.fallback.display, // Don't add extra text, backend handles it
                            }];
                    }
                    throw new Error(response.data.message || "Processing failed");
            }
        });
    }); };
    var applyValue = function (field, value) {
        var o = optsRef.current;
        switch (field) {
            case "position": {
                var matched = o.positions.find(function (p) { return p.position.toLowerCase() === value.toLowerCase(); });
                if (matched)
                    o.onSetPosition(matched.id.toString());
                break;
            }
            case "date":
                o.onSetDate(value);
                break;
            case "start_time":
                o.onSetStartTime(value);
                break;
            case "end_time":
                o.onSetEndTime(value);
                break;
            case "vessel_name":
                o.onSetVessel(value);
                o.onShowShip(value.trim().toUpperCase() !== "YARD");
                break;
            case "ship_name":
                o.onSetShip(value);
                break;
            case "header_name":
                o.onSetHeader(value);
                break;
        }
    };
    var runStep = function (stepIndex) { return __awaiter(void 0, void 0, Promise, function () {
        var steps, step, audio, err_1, value, display, result, _a, next;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    steps = getSteps();
                    if (!(stepIndex >= steps.length)) return [3 /*break*/, 2];
                    setVoiceState("done");
                    setStatusMessage("All fields filled!");
                    return [4 /*yield*/, speak("All done! Your time log has been filled in. Please review and press Add to save.")];
                case 1:
                    _c.sent();
                    setIsActive(false);
                    setVoiceState("idle");
                    (_b = wakeLockRef.current) === null || _b === void 0 ? void 0 : _b.release().catch(function () { });
                    wakeLockRef.current = null;
                    return [2 /*return*/];
                case 2:
                    step = steps[stepIndex];
                    setCurrentStepIndex(stepIndex);
                    // ASK
                    setVoiceState("asking");
                    setStatusMessage(step.getQuestion());
                    return [4 /*yield*/, speak(step.getQuestion())];
                case 3:
                    _c.sent();
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    // RECORD
                    setVoiceState("listening");
                    setStatusMessage("Listening…");
                    setLiveTranscript("");
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 13]);
                    return [4 /*yield*/, recordAudio()];
                case 5:
                    audio = _c.sent();
                    return [3 /*break*/, 13];
                case 6:
                    err_1 = _c.sent();
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    if (!(err_1.message === "no-speech")) return [3 /*break*/, 8];
                    return [4 /*yield*/, speak("I didn't catch anything. Let me ask again.")];
                case 7:
                    _c.sent();
                    return [3 /*break*/, 12];
                case 8:
                    if (!(err_1.message === "mic-denied")) return [3 /*break*/, 10];
                    return [4 /*yield*/, speak("Microphone access was denied. Please allow microphone access and try again.")];
                case 9:
                    _c.sent();
                    setIsActive(false);
                    setVoiceState("idle");
                    return [2 /*return*/];
                case 10: return [4 /*yield*/, speak("There was a microphone error. Let me try again.")];
                case 11:
                    _c.sent();
                    _c.label = 12;
                case 12: return [2 /*return*/, runStep(stepIndex)];
                case 13:
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    // PROCESS
                    setVoiceState("processing");
                    setStatusMessage("Understanding your answer…");
                    setLiveTranscript("");
                    _c.label = 14;
                case 14:
                    _c.trys.push([14, 16, , 18]);
                    return [4 /*yield*/, processWithGemini(step.key, audio, step.getOptions())];
                case 15:
                    result = _c.sent();
                    value = result.value;
                    display = result.display;
                    return [3 /*break*/, 18];
                case 16:
                    _a = _c.sent();
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    return [4 /*yield*/, speak("I had a little trouble with that. Let me ask again.")];
                case 17:
                    _c.sent();
                    return [2 /*return*/, runStep(stepIndex)];
                case 18:
                    if (!!value) return [3 /*break*/, 20];
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    return [4 /*yield*/, speak("I wasn't sure what you said. Let me try again.")];
                case 19:
                    _c.sent();
                    return [2 /*return*/, runStep(stepIndex)];
                case 20:
                    applyValue(step.key, value);
                    // CONFIRM
                    setVoiceState("confirming");
                    setStatusMessage("Got it \u2014 ".concat(display));
                    return [4 /*yield*/, speak("Got it, ".concat(display, "."))];
                case 21:
                    _c.sent();
                    if (stoppedRef.current)
                        return [2 /*return*/];
                    next = stepIndex + 1;
                    if (step.key === "vessel_name" && value.trim().toUpperCase() === "YARD") {
                        next = stepIndex + 2;
                    }
                    return [4 /*yield*/, runStep(next)];
                case 22:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var start = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (isActive)
                        return [2 /*return*/];
                    if (!((_c = navigator.mediaDevices) === null || _c === void 0 ? void 0 : _c.getUserMedia)) {
                        alert("Your browser does not support audio recording. Please use Chrome, Edge, or Firefox.");
                        return [2 /*return*/];
                    }
                    stoppedRef.current = false;
                    setIsActive(true);
                    setCurrentStepIndex(0);
                    setLiveTranscript("");
                    setStatusMessage("Starting voice assistant…");
                    setVoiceState("asking");
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    if (!("wakeLock" in navigator)) return [3 /*break*/, 3];
                    _a = wakeLockRef;
                    return [4 /*yield*/, navigator.wakeLock.request("screen")];
                case 2:
                    _a.current = _d.sent();
                    _d.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _b = _d.sent();
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, speak("Hello! I'll help you fill in the time log. Just answer each question naturally.")];
                case 6:
                    _d.sent();
                    return [4 /*yield*/, runStep(0)];
                case 7:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var stop = function () {
        var _a;
        stoppedRef.current = true;
        setIsActive(false);
        setVoiceState("idle");
        setStatusMessage("");
        setLiveTranscript("");
        window.speechSynthesis.cancel();
        (_a = wakeLockRef.current) === null || _a === void 0 ? void 0 : _a.release().catch(function () { });
        wakeLockRef.current = null;
        if (mediaRecorderRef.current) {
            try {
                mediaRecorderRef.current.stop();
            }
            catch ( /* ignore */_b) { /* ignore */ }
            mediaRecorderRef.current = null;
        }
        if (audioStreamRef.current) {
            audioStreamRef.current.getTracks().forEach(function (t) { return t.stop(); });
            audioStreamRef.current = null;
        }
    };
    return {
        isActive: isActive,
        voiceState: voiceState,
        currentStepIndex: currentStepIndex,
        liveTranscript: liveTranscript,
        statusMessage: statusMessage,
        start: start,
        stop: stop,
    };
};
export default useVoiceInput;
